import { fetcher } from "helpers/fetcher";

import { TGetAddressByZipCodeReq, TGetAddressByZipCodeRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getAddressByZipCode = async (
  payload?: TGetAddressByZipCodeReq
) => {
  return await fetcher<TGetAddressByZipCodeRes, TGetAddressByZipCodeReq>(
    ENDPOINT.CORPORATION.GET_ADDRESS_BY_ZIP_CODE,
    {
      params: payload,
      headers: {
        [API_HEADER.VERSION]:
          ENDPOINT.CORPORATION.GET_ADDRESS_BY_ZIP_CODE.version,
      },
    }
  );
};

export const queryGetAddressByZipCode = async (
  payload?: TGetAddressByZipCodeReq
) => {
  return (await getAddressByZipCode(payload)).data;
};

queryGetAddressByZipCode._key = (
  payload?: TGetAddressByZipCodeReq,
  key?: string
) => [ENDPOINT.CORPORATION.GET_ADDRESS_BY_ZIP_CODE.url, payload, key];
